module.exports = __webpack_public_path__ + "3b3684d98d352a78cd0b1036bde78fa7.png";